import Cookies from 'js-cookie'

jQuery(document).ready(function (e) {

    function checkCookie() {
        if (Cookies.get('closed_announcement') === 'closed') {
            return true;
        } else {
            return false;
        }
    }

    jQuery('.header__announcement button').click(function () {


        if (checkCookie()) {

            return false; // Prevent further execution of the function
        }

        Cookies.set('closed_announcement', 'closed');
        jQuery('.header__announcement').removeClass('not_closed');
        jQuery('.has_announcement_bar').removeClass('not_closed');

    });

    // Check if user has closed announcement on page load and add class if true
    if (checkCookie()) {
        jQuery('.header__announcement').removeClass('not_closed');
        jQuery('.has_announcement_bar').removeClass('not_closed');
    }else{
        jQuery('.header__announcement').addClass('not_closed');
        jQuery('.has_announcement_bar').addClass('not_closed');
    }

});